import React, { useState } from 'react';
import {
    Drawer,
    Button,
    Box,
    Typography,
    IconButton,
    Divider,
    useTheme,
    useMediaQuery
} from '@mui/material';
import {
    FilterList as FilterIcon,
    Close as CloseIcon
} from '@mui/icons-material';

const Filter = ({ children, onFilter, onClear }) => {
    const [isOpen, setIsOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const handleFilter = () => {
        if (onFilter) {
            onFilter();
        }
    };

    const handleClear = () => {
        if (onClear) {
            onClear();
        }
    };

    const handleClose = () => {
        setIsOpen(false); 
    };
    

    return (
        <>
            <Button
                variant="contained"
                startIcon={<FilterIcon />}
                onClick={() => setIsOpen(true)}
                sx={{
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 500,
                    boxShadow: 2,
                    '&:hover': {
                        boxShadow: 4,
                        transform: 'translateY(-1px)',
                    },
                    transition: 'all 0.2s ease',
                }}
            >
                Filtros
            </Button>
            <Drawer
                anchor="right"
                open={isOpen}
                onClose={handleClose}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: isMobile ? '70vw' : 400,
                        boxSizing: 'border-box',
                    },
                }}
            >
                <Box
                    sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Box
                        sx={{
                            p: 3,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            backgroundColor: theme.palette.grey[50],
                            borderBottom: `1px solid ${theme.palette.divider}`,
                        }}
                    >
                        <Typography variant="h6" component="h2" fontWeight={600}>
                            Filtros
                        </Typography>
                        <IconButton
                            onClick={handleClose}
                            size="small"
                            sx={{
                                '&:hover': {
                                    backgroundColor: theme.palette.grey[200],
                                },
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Box
                        sx={{
                            flex: 1,
                            p: 3,
                            overflow: 'auto',
                            backgroundColor: theme.palette.background.paper,
                        }}
                    >
                        {children}
                    </Box>

                    <Divider />

                    <Box
                        sx={{
                            p: 3,
                            backgroundColor: theme.palette.grey[50],
                            display: 'flex',
                            flexDirection:{xs:'column' , sm:'row'},
                            gap: 2,
                        }}
                    >

                        <Button
                            variant="outlined"
                            onClick={handleClear}
                            fullWidth
                            sx={{
                                textTransform: 'none',
                                fontWeight: 500,
                                borderRadius: 2,
                                '&:hover': {
                                    transform: 'translateY(-1px)',
                                    boxShadow: 2,
                                },
                                transition: 'all 0.2s ease',
                            }}
                        >
                            Limpar Filtros
                        </Button>

                        <Button
                            variant="contained"
                            onClick={handleFilter}
                            fullWidth
                            sx={{
                                textTransform: 'none',
                                fontWeight: 500,
                                borderRadius: 2,
                                '&:hover': {
                                    transform: 'translateY(-1px)',
                                    boxShadow: 4,
                                },
                                transition: 'all 0.2s ease',
                            }}
                        >
                            Filtrar
                        </Button>
                    </Box>
                </Box>
            </Drawer>
        </>
    );
};

export default Filter;